export const getContentType = (extension: string | undefined): string => {
  if (!extension) return "application/octet-stream";
  switch (extension.toLowerCase()) {
    case "json":
      return "application/json";
    case "svg":
      return "image/svg+xml";
    case "png":
      return "image/png";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "txt":
      return "text/plain";
    case "html":
      return "text/html";
    case "css":
      return "text/css";
    case "js":
      return "application/javascript";
    case "geojson":
      return "application/geo+json";
    default:
      return "application/octet-stream";
  }
};
